import { SvelteMap } from "svelte/reactivity";

export interface PageHole {
  after: number;
  before: number;
}

// The hole a hydrate left between the rows it kept and its page, until the read-back ends:
// an open's "New" line can't be placed over it, the first unread may be in it.
export class PageHoles {
  private readonly held = new SvelteMap<string, PageHole>();

  of(agentId: string): PageHole | undefined {
    return this.held.get(agentId);
  }

  open(agentId: string, hole: PageHole): void {
    this.held.set(agentId, hole);
  }

  // A read-back that ended, read or lost, over the whole of the hole.
  settle(agentId: string, range: PageHole): void {
    const hole = this.held.get(agentId);
    if (hole && range.after <= hole.after && range.before >= hole.before) this.held.delete(agentId);
  }

  forget(agentId: string): void {
    this.held.delete(agentId);
  }

  clear(): void {
    this.held.clear();
  }
}
